export default function PreparationItemDocumentController(
  $q,
  $rootScope,
  $scope,
  alerts,
  amDataService,
  amSharedModelService,
  confirmDialog,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService
) {
  const vm = this;

  // Set Default Values
  vm.canExpand = vm.status !== 'No Preparation Item Document Added';
  vm.isExpanded = false;
  vm.canDeleteItem = vm.canDelete;
  vm.canEditItem = vm.canEdit;

  // Attach Event Handlers
  vm.handleUnattachPreparationItemDocument = _handleUnattachPreparationItemDocument;
  vm.handleConfirmDelete = _handleConfirmDelete;
  vm.handleCancelDelete = _handleCancelDelete;

  function _handleUnattachPreparationItemDocument($event) {
    ssDialogService.dialogs.auditTrail.deletePreparationItemDocumentConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Remove Preparation Item Document?',
        message: `Are you sure you want to remove document "${vm.preparationItemDocument.description}"?`,
        handleYesClick: _handleConfirmDelete,
        handleNoClick: _handleCancelDelete,
      })
    );

    ssDialogService.show(ssDialogService.dialogs.auditTrail.deletePreparationItemDocumentConfirmDialog);
  }

  function _handleConfirmDelete() {
    loaderService.showViewLoader = true;
    return amDataService.detachPreparationItemDocument(vm.preparationItemDocument.preparationItemDocumentId)
      .then(() => {
        alerts.success('The document has been removed successfully.');
        $rootScope.$broadcast('refreshAMPreparationItemDocuments',
          { preparationItemId: vm.preparationItemDocument.preparationItemId });
        _closeDeleteDialog();
      }).catch(() => {
        alerts.error('Error occurred while removing the document.');
      }).finally(() => {
        loaderService.showViewLoader = false;
      });
  }

  function _handleCancelDelete() {
    _closeDeleteDialog();
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.auditTrail.deletePreparationItemDocumentConfirmDialog);
  }
}

PreparationItemDocumentController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'amDataService',
  'amSharedModelService',
  'confirmDialog',
  'docDataService',
  'loaderService',
  'orgDataService',
  'ssDialogService'
];
